import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "style"
    }}>{`Style`}</h3>
    <p><inlineCode parentName="p">{`Model`}</inlineCode>{` uses the `}<a parentName="p" {...{
        "href": "https://rebassjs.org/"
      }}>{`rebass`}</a>{` component system.
Rebass is part of a larger ecosystem that includes `}<a parentName="p" {...{
        "href": "https://theme-ui.com/"
      }}>{`theme-ui`}</a>{` and the `}<a parentName="p" {...{
        "href": "https://styled-system.com/"
      }}>{`styled system`}</a>{`.`}</p>
    <p>{`As such, `}<inlineCode parentName="p">{`Model`}</inlineCode>{` can take a theme-ui `}<inlineCode parentName="p">{`theme`}</inlineCode>{` and styled system `}<inlineCode parentName="p">{`sx`}</inlineCode>{` props.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`theme`}</strong><br />{`object, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A `}<a parentName="td" {...{
              "href": "https://theme-ui.com/"
            }}>{`theme-ui`}</a>{` theme.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`sx`}</strong><br />{`object, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A `}<a parentName="td" {...{
              "href": "https://styled-system.com/"
            }}>{`styled system`}</a>{` style prop.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      